import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {SharedService} from "../../services/store/shared-store/shared-storage.service";
import { MatToolbar } from '@angular/material/toolbar';
import { ApprovalsComponent } from './approvals/approvals.component';

@Component({
    selector: 'app-flow-management',
    templateUrl: './flow-management.component.html',
    styleUrls: ['./flow-management.component.scss'],
    imports: [MatToolbar, ApprovalsComponent]
})
export class FlowManagementComponent {
  constructor(public dialogRef: MatDialogRef<FlowManagementComponent>,public sharedService: SharedService) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
